(function($) {
  var $tabs = $('.sister-properties-tabs');

  $tabs.on('click', '[data-toggle=tab]', function(event) {
    var button = this;
    var item = $(button).parents('.sister-properties-tabs__nav-item')
    $(button).tab('show')
    $(button)
      .addClass('active')
      .attr('aria-selected', true)
    $(item).siblings('.sister-properties-tabs__nav-item').find('a')
      .removeClass('active')
      .attr('aria-selected', false)
  })
})(jQuery);